var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.645,
    height: 55.897,
    viewBox: "0 0 54.645 55.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16645",
    "data-name": "Path 16645",
    d: "M263.023,690.034a20.93,20.93,0,1,0-6.45,5.953l15.457,15.408a4.4,4.4,0,0,0,6.368-6.066l-.164-.164Zm-17.111,1.432a13.559,13.559,0,1,1,13.506-13.585,13.548,13.548,0,0,1-13.506,13.585Z",
    transform: "translate(-224.956 -656.866)",
    fill: "#2c53bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d5b956eb727d9b68e9587e046bc487d3.svg";
export { ForwardRef as ReactComponent };